import React from 'react';
import Div from "@jumbo/shared/Div";
import { LEADS } from 'app/utils/constants/endPoint';
import DataTable from 'app/components/DataTable/DataTable';
import { requestApi } from 'app/utils/RestApi';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { isMobile } from 'react-device-detect';

// end of style table	
const MicrositeHistoryPaymentPerLead = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const queryParams = new URLSearchParams(location.search);
	
	const [userData, setUserData] = React.useState(null)

	React.useEffect(() => {
		const userdata = localStorage.getItem('userdata')
		const dataLogin = JSON.parse(userdata)
		setUserData(dataLogin)
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	React.useEffect(() => {
		fetchData()
	}, [userData]);

	const [total, setTotal] = React.useState(0);

	const fetchData = async () => {
		await requestApi(LEADS.PAYMENT_HISTORY_CALCULATE_PER_LEAD, {
			subfolder: '/' + queryParams.get('id')
		}).then(({ data }) => {
			if (data?.status === 'success') {
				setTotal(data.data)
			}
		}).catch((err) => {
			console.log("PAYMENT_HISTORY_CALCULATE_PER_LEAD err : ", err)
		})
	}

	const customContent = <Div className='grandtotal-container'><h6 className='mb-0'>Grand Total : <span className='grandtotal-value'>{new Intl.NumberFormat('de-DE', {
		maximumFractionDigits: 0
	}).format(total)}</span></h6></Div>;


	const columns = [
		{ field: 'id', headerName: 'No', minWidth: isMobile ? 100 : 40 },
		{ field: 'paymentDueDate', headerName: 'Tanggal Bayar', minWidth: isMobile ? 170 : 150, flex: 1 },
		{
			field: 'commissionReferral', headerName: 'Jumlah Fee (Gross)', minWidth: isMobile ? 210 : 150, flex: 1,
			valueFormatter: (params) => {
				const valueFormatted = new Intl.NumberFormat('de-DE', {
					maximumFractionDigits: 0
				}).format(params.value);

				return valueFormatted;
			}
		},
		{ field: 'caseNo', headerName: 'Case No', minWidth: isMobile ? 130 : 100, flex: 1 },
		{ field: 'policyStatus', headerName: 'Policy Status', minWidth: isMobile ? 150 : 100, flex: 1 },
		{ field: 'issuedDate', headerName: 'Tanggal Issued SPAJ', minWidth: 200, flex: 1 },
		{
			field: 'commissionReferralRate', headerName: 'Fee Rate', minWidth: isMobile ? 130 : 100, flex: 1,
			valueFormatter: (params) => {
				const valueFormatted = new Intl.NumberFormat('de-DE', {
					maximumFractionDigits: 0,
				}).format(params.value);

				return valueFormatted + '%';
			}
		}
	]

	const backHandler = () => {
		navigate(-1);
	};

	return (
		<Div className='content-padding'>
			<Div className='back-icon'>
				<KeyboardBackspaceIcon onClick={backHandler} />
			</Div>
			<Div className='white-container mt-5'>
				<Div className='section-header'>History Payment Lead : {queryParams.get('name')}</Div>
				<Div sx={{ overflowX: 'auto' }}>
					<DataTable
						columns={columns}
						endPoint={LEADS.PAYMENT_HISTORY_PER_LEAD}
						downloadUrl={LEADS.PAYMENT_HISTORY_PER_LEAD_DOWNLOAD}
						policyNo={queryParams.get('id')}
						customContent={customContent} />
				</Div>
			</Div>
		</Div>

	);
};

export default MicrositeHistoryPaymentPerLead;